import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

// "3 of 10" when the building's floor count is known, otherwise just the floor.
export const getFloorOfFloorsLabel = (
  floor: Nullable<number | string>,
  floorCount: Nullable<number | string>
): Nullable<number | string> => {
  if (isValuePresent(floor) && isValuePresent(floorCount)) {
    return `${floor} of ${floorCount}`;
  }

  return floor ?? null;
};
